// extracted by mini-css-extract-plugin
module.exports = {"mwebLocationSearchInputWrapper":"FilterBar--mwebLocationSearchInputWrapper","searchIcon":"FilterBar--searchIcon","searchIconWithCart":"FilterBar--searchIconWithCart"};